import React, { Component } from "react";
import { getSiteRootUrl, RoutedViewProps } from "@my-dld/utils/UrlUtils";
import { hideLoading, showLoading } from "@my-dld/utils/UIUtils";
import Strings from "@my-dld/assets/strings";
import { EIDModal, EidStateFormatter } from "../../owner/EID";
import { I8N, StringUtil } from "@eres/core";
import { SSOApi } from "@eres/ssoapi";
import { convertToEidaClientProfile, convertToEidaServerProfile, EIDAClientProfile } from "@eres/ssoapi/entities";
import { SSORegContext, Step } from "@my-dld/contexts/RegisterContext";
import { exToMessage, getUaePassUrl } from "@eres/ssoapi/api";
import _ from "lodash";
import ProfileInfo from "./forms/Profile";
import VerifyOTP from "./forms/Verify";
import UserInfo from "./forms/UserId";
import * as base64 from "js-base64";
import { IAppLoginState } from "../../index";
import { isUaePassEnabled } from "@my-dld/utils/Utils";
import FixedEidInput from "@my-dld/components/FixedEidInput";
import ReCAPTCHA from "react-google-recaptcha";

interface Prop extends RoutedViewProps<{ appId: string }> {

}


interface State {
	eid?: string;
	error?: string;
	profile?: EIDAClientProfile;
	oProfile?: EIDAClientProfile;
	captchaResponse?: string;
	captchaError?: string;
	showCaptcha: boolean;
}

class EidForm extends Component<Prop, State> {
	static contextType = SSORegContext;
	context!: React.ContextType<typeof SSORegContext>;
	captcha = React.createRef<ReCAPTCHA>();

	constructor( props: Prop ) {
		super( props );

		this.state = {
			eid: window.setOTP ? "784196310505498" : "784", //"784"
			showCaptcha: window.AppInfo.noCaptcha !== true,
		};
	}

	setLoading = ( isLoading: boolean ) => {
		if ( isLoading ) {
			showLoading();
		} else hideLoading();
	};

	componentDidMount() {
		if ( this.context.profile ) {
			this.setState( {
				profile: this.context.profile!,
			} );
		}
	}

	render() {
		const { error } = this.state;
		const { step } = this.context;
		let isEid = step === Step.eid; //
		if ( step === Step.done ) return null;
		return (
			<React.Fragment>
				<>
                        {step == Step.eid && <>
                            <label htmlFor="eid">{Strings.emirates_id_number} <span className="asterisk"> *</span></label>
							<FixedEidInput
                                containerClassName={ "form-group mb-12 field-style field-help" }
								id={ "eid" }
                                holder={this}
                                noLabel={true}
                                disabled={!isEid}
								required={ true }
								error={ this.state.error }
								placeHolder={ "784-XXXX-XXXXXX-X" }
								stateFormatter={ EidStateFormatter }
							>
                                <button className="btn-input-icon" type="button" data-bs-toggle="modal" data-bs-target="#emiratesIDInfoModal">
                                    <span className="material-icons-outlined">info</span>
                                </button>
							</FixedEidInput>
							{ this.state.showCaptcha &&
								<div className="form-group">
									<ReCAPTCHA
										ref={ this.captcha }
										sitekey={ window.AppInfo.recaptchaSiteKey! }
										hl={ I8N.locale() }
										onChange={ this.onCaptchaChange }
										onErrored={ this.onCaptchaExpired }
										onExpired={ this.onCaptchaExpired }
									/>
									{ this.state.captchaError && <div className={ "invalid-feedback invalid-feedback-x" }>
										{ this.state.captchaError }
									</div> }
								</div>
							}
                            <button
                                className="btn btn_1 btn_style1 mb-2"
                                onClick={this.onContinue}>{isEid ? Strings.continue : Strings.change_eid}</button>
							{ isUaePassEnabled() && <>
								<div className="sso-or-div"><span>{ Strings.or_caps }</span></div>
                                <button className="btn btn-signup-uaepass" onClick={this.uaePass}>
                                    <span className="sr-only">UAE Pass Registration</span>
                            </button>
                            <div className="uae-pass-text">
                                <span>{Strings.how_to_register_for_uae_pass} <a
                                    href={Strings.watch_video_link} rel="noopener noreferrer" target="_blank">{Strings.watch_video}</a></span>
                            </div>
							</> }
							<EIDModal/>
						</> }
						{ !( step == Step.eid || step == Step.uid ) && <>
							<ProfileInfo
								key={ step } profile={ this.state.profile! } onChange={ this.onChangeEID }
								step={ step }
								onProceed={ step === Step.profile_confirm ? this.onProfileConfirm : this.onConfirm }/>

						</> }
						{ step === Step.verify &&

							<VerifyOTP
								profile={ this.state.profile! } onConfirmed={ this.onVerified }
								onCancel={ this.onVerifyCancel }/>
						}
						{ ( step === Step.uid ) && <>
							<UserInfo onCreated={ this.onDone }/>
						</> }
						{ ( step !== Step.eid ) && error && <div className="invalid-feedback invalid-feedback-x">
							{ error }
						</div> }
				</>
			</React.Fragment>
		);
	}

	onCaptchaChange = ( token: string | null ) => {
		this.setState( { captchaResponse: token!, captchaError: undefined } );
	};
	onCaptchaExpired = () => {
		this.setState( { captchaResponse: undefined } );
	};
	resetCaptcha = () => {
		if ( this.captcha.current ) this.captcha.current.reset();
		this.setState( { captchaResponse: undefined } );
	};
	onVerifyCancel = () => {
		this.context.update!( {
			step: Step.confirm,
		} );
	};
	onProfileConfirm = () => {
		this.context.update!( {
			step: Step.uid,
		} );
	};
	uaePass = () => {
		showLoading();
		const ln = I8N.locale();
		const appState: IAppLoginState = {
			module: "uaepass",
			sso: false,
			app: this.context.app!.id,
			ln: ln,
			mode: "reg",
		};
		const state = base64.encode( JSON.stringify( appState ) );
		const passUrl = getUaePassUrl( ln, state );
		window.location.href = passUrl;

	};
	onDone = () => {
		this.context.update!( {
			step: Step.done,
		} );
		this.props.history.replace( "/sso/register/done" );
	};
	onVerified = ( profile: EIDAClientProfile ) => {
		this.setState( {
			profile: profile,
		}, () => {
			this.context.update!( {
				step: Step.profile_confirm,
			} );
		} );
	};

	onConfirm = ( profile: EIDAClientProfile ) => {
		this.setState( {
			error: undefined,
		} );
		this.setLoading( true );
		SSOApi.register.confirm( convertToEidaServerProfile( profile ) )
		.then( r => {
			this.setLoading( false );
			this.setState( {
				profile: convertToEidaClientProfile( r.data )
			} );
			this.context.update!( {
				step: Step.verify,
			} );
		} )
		.catch( e => {
			exToMessage( e ).then( message => {
				this.setLoading( false );
				this.setState( { error: message.error } );
			} );
		} );
	};
	onChangeEID = () => {
		this.setState( {
			profile: undefined,
			error: undefined,
		}, () => {
			this.context.update!( {
				step: Step.eid,
			} );
		} );
	};
	onContinue = () => {
		this.setState( { captchaError: undefined } );
		const { step } = this.context;
		let isEid = step === Step.eid;
		this.setState( {
			error: undefined,
		} );
		this.context.update!( { newEmail: undefined } );
		if ( StringUtil.isEmptyStringOrNull( this.state.eid ) ) {
			this.setState( { error: Strings.required } );
		} else if ( this.state.eid?.length !== 15 ) {
			this.setState( { error: Strings.invalid_eid } );
		} else if ( this.state.showCaptcha && StringUtil.isEmptyStringOrNull( this.state.captchaResponse ) ) {
			this.setState( { captchaError: Strings.required } );
		} else {
			this.setLoading( true );
			SSOApi.register.eid( this.state.eid!, this.state.showCaptcha ? this.state.captchaResponse! : "" )
			.then( r => {
				this.resetCaptcha();
				this.setLoading( false );
				let profile = convertToEidaClientProfile( r.data );
				this.setState( {
					profile: profile,
					oProfile: _.cloneDeep( profile ),
				}, () => {
					this.context.update!( {
						step: Step.confirm,
					} );
				} );
			} )
			.catch( e => {
				this.resetCaptcha();
				exToMessage( e ).then( message => {
					this.setLoading( false );
					this.setState( { error: message.error } );
				} );
			} );
		}
	};
}


export default EidForm;
